import styled from "@emotion/styled";

const Requerido = styled.span`
  color: #d1424f;
  margin-left: 2px;
  font-weight: 700;
`;

/** Texto del label con el asterisco de obligatorio pegado (cotizador y pantalla del vendedor). */
export const conAsterisco = (texto: string) => (
  <span>
    {texto}
    <Requerido aria-hidden="true">*</Requerido>
  </span>
);
